<div class="register-container">
  <div class="branding">
    <img src="/favicon.ico" alt="Kitty On Demand Logo" class="branding-logo" />
  </div>
  <mat-card>
    <mat-card-title>Register</mat-card-title>
    <mat-card-content>
      <form [formGroup]="registerForm" (ngSubmit)="register()">
        <mat-form-field appearance="fill">
          <mat-label>Display Name</mat-label>
          <input matInput type="text" formControlName="displayName" placeholder="How should we call you?" required>
          <mat-error *ngIf="registerForm.get('displayName')?.hasError('required')">
            Display name is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('displayName')?.hasError('minlength')">
            Display name must be at least 2 characters
          </mat-error>
          <mat-error *ngIf="registerForm.get('displayName')?.hasError('maxlength')">
            Display name cannot exceed 50 characters
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" placeholder="We won't spam (probably)" required>
          <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" required>
          <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
            Password is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('password')?.hasError('minlength')">
            Password must be at least 6 characters long
          </mat-error>
          <mat-error *ngIf="registerForm.get('password')?.hasError('pattern')">
            Password must contain at least one letter and one number
          </mat-error>
        </mat-form-field>
        <mat-checkbox formControlName="acceptGuidelines" required>
          I have read and accept the <a href="/community-guidelines" target="_blank" rel="noopener">Community Guidelines</a>
        </mat-checkbox>
        <mat-error *ngIf="registerForm.get('acceptGuidelines')?.hasError('required') && registerForm.get('acceptGuidelines')?.touched">
          You must accept the Community Guidelines to register.
        </mat-error>
        <br>
        <button mat-raised-button color="primary" type="submit" [disabled]="registerForm.invalid || loading" class="register-button">
          <ng-container *ngIf="!loading; else loadingTpl">Register</ng-container>
          <ng-template #loadingTpl>
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </ng-template>
        </button>
        <div class="login-link">
          <a href="/login">Already have an account? Login</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
